import {Content} from "pdfmake/interfaces";
import {primaryColor} from "../../../../consts";
import {SIDE_MARGINS} from "./getJSONForGeneralSpecification";

export const getPrimarySpecificationTableHeader = () => {
    const productTableHeader = [];
    const tableFontSize = 14;
    const header: Content = {
        margin: [SIDE_MARGINS, 25, SIDE_MARGINS, 10],
        color: primaryColor,
        table: {
            widths: ['*', 100],
            body: [
                [
                    {
                        border: [false, false, false, true],
                        borderColor: ['', '', '', primaryColor],
                        text: 'Товар',
                        alignment: 'left',
                        fontSize: tableFontSize,
                        bold: false,
                    },
                    {
                        border: [false, false, false, true],
                        borderColor: ['', '', '', primaryColor],
                        text: 'Количество',
                        alignment: 'center',
                        fontSize: tableFontSize,
                        bold: false,
                    },
                ]
            ],
        }
    };
    productTableHeader.push(header);
    return productTableHeader
}
